import TeaserBaseView from './TeaserBaseView';

export default TeaserBaseView.extend({
  events: {
    'click .ui-slider-to-left': 'onClickToTheLeft',
    'click .ui-slider-to-right': 'onClickToTheRight',
    'touchstart .content': 'onTouchStart',
    'touchend .content': 'onTouchEnd'
  },

  fadeTime: 600,
  treshold: 100,

  postInit: function() {
    // show what was hidden in BaseView.init
    this.$teasers.show();
    this.$el.width(this.$el.data('width'));
    this.$el.height(this.$el.data('height'));
    this.$container = this.$('.content');
  },

  toGlobalFallback: function() {
    this.$('.ui-slider-to-left').hide();
    this.$('.ui-slider-to-right').hide();
  },

  onTimeout: function() {
    if (!this.blockTransition) {
      this.onClickToTheRight();
    }
  },

  onClickToTheLeft: function() {
    this.fadeTo(this.getPrevTeaser());
    this.restartTimer();
  },

  onClickToTheRight: function() {
    this.fadeTo(this.getNextTeaser());
    this.restartTimer();
  },

  fadeTo: function(target) {
    var activeTeaser = this.activeTeaser;
    var teaserCount = this.$teasers.length;
    var distanceLeft =
      activeTeaser <= target
        ? teaserCount + activeTeaser - target
        : activeTeaser - target;
    var distanceRight =
      activeTeaser >= target
        ? teaserCount + target - activeTeaser
        : target - activeTeaser;

    if (distanceLeft > distanceRight) {
      this.slideRight(distanceRight);
    } else {
      this.slideLeft(distanceLeft);
    }
  },

  slideRight: function(distance) {
    if (this.isSliding) {
      return;
    }
    this.isSliding = true;

    this.$container.css({
      left: -(distance * this.$el.width()),
      transition: 'left ease-out ' + this.fadeTime + 'ms'
    });

    setTimeout(
      function() {
        for (var i = 0; i < distance; i++) {
          this.$container
            .find('.teaser-element:first')
            .appendTo(this.$container);
        }
        this.$container.css({
          left: 0,
          transition: 'none'
        });

        this.isSliding = false;
      }.bind(this),
      distance * this.fadeTime + this.treshold
    );
  },

  slideLeft: function(distance) {
    if (this.isSliding) {
      return;
    }
    this.isSliding = true;

    for (var i = 0; i < distance; i++) {
      this.$container.find('.teaser-element:last').prependTo(this.$container);
    }
    this.$container.css({
      left: -(distance * this.$el.width())
    });

    setTimeout(
      function() {
        this.$container.css({
          left: 0,
          transition: 'left ease-out ' + this.fadeTime + 'ms'
        });
      }.bind(this),
      0
    );

    setTimeout(
      function() {
        this.$container.css({
          transition: 'none'
        });
        this.isSliding = false;
      }.bind(this),
      distance * this.fadeTime + this.treshold
    );
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/TeaserSlideView.js
 **/